/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notfound_DescriptionInputs */



/**
* | output |
* | --- |
* | "We couldn't find the page you're looking for. It might have been moved or deleted." |
*
* @param {Notfound_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notfound_description = /** @type {((inputs?: Notfound_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notfound_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wir konnten die gesuchte Seite nicht finden. Sie wurde möglicherweise verschoben oder gelöscht.")
	return /** @type {LocalizedString} */ ("We couldn't find the page you're looking for. It might have been moved or deleted.")
});